import PropTypes from 'prop-types';
import React from 'react';

const ArrowRight = ({ color }) => {
  return (
    <svg
      fill="none"
      height="9"
      viewBox="0 0 18 9"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 4.46387H15" stroke={color} strokeWidth="1.5" />
      <path d="M17.5 4.4641L12.5 8.9282V0L17.5 4.4641Z" fill={color} />
    </svg>
  );
};

ArrowRight.propTypes = {
  color: PropTypes.string,
};

export default ArrowRight;
